(function () {
  const ChatForm = () => {
    const showWaitingMessage = () => {
      const waitingMessage = document.getElementById('waiting-message');
      waitingMessage?.classList.replace('hidden', 'flex');
    }

    return {
      handleEnter(event) {
        if (event.shiftKey) return;

        event.preventDefault();

        this.submitMessage();
      },

      submitMessage() {
        const input = this.$refs.input;
        if (!input.value.trim()) return;

        document.getElementById('form-message').requestSubmit();

        input.value = '';

        showWaitingMessage();

        this.$nextTick(() => {
          const list = document.getElementById('message-list');
          if (list) list.scrollTop = list.scrollHeight;
        })
      }
    }
  };

  if (typeof window !== 'undefined') {
    window.ChatForm = ChatForm;
  };

  return ChatForm;
})();
